import { render, staticRenderFns } from "./TotpResetLink.vue?vue&type=template&id=7a4a859a&"
import script from "./TotpResetLink.vue?vue&type=script&lang=js&"
export * from "./TotpResetLink.vue?vue&type=script&lang=js&"
import style0 from "./TotpResetLink.vue?vue&type=style&index=0&id=7a4a859a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports